import {removeUrlHash} from '@github-ui/history'
import {controller} from '@github/catalyst'

@controller
class JobSummariesElement extends HTMLElement {
  connectedCallback() {
    // Event listener is placed on the document since we need to check for any click outside the targetted summary
    document.addEventListener('click', this.checkForHashReset.bind(this))
  }

  disonnectedCallback() {
    document.removeEventListener('click', this.checkForHashReset.bind(this))
  }

  /**
   * Checks if the click was _outside_ the targetted summary, reset the hash and scroll
   * Based on: https://github.com/github/github/blob/df25b4c8377d91e73274a8b625784a6ae7413f4a/app/assets/modules/github/behaviors/targetable-elements.ts#L23
   */
  checkForHashReset(event: MouseEvent) {
    const targetElement = this.querySelector('job-summary:target')
    if (!targetElement) return

    if (!(event.target instanceof HTMLElement)) return
    if (targetElement.contains(event.target)) return

    const prevScrollHeight = window.scrollY

    removeUrlHash()

    if (prevScrollHeight) {
      window.scrollTo({top: prevScrollHeight})
    }
  }
}
